import React, { Component } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Container } from 'reactstrap';
import withAuthProvider, { AuthComponentProps } from './msal/AuthProvider';
import NavBar from './component/NavBar';
import ErrorMessage from './component/ErrorMessage';
import ConfigEditor from './component/ConfigEditor/ConfigEditor';
import ServiceManager from "./component/ServiceManager/ServiceManager";
import SecretManager from "./component/SecretManager/SecretManager";
import 'bootstrap/dist/css/bootstrap.css';

class App extends Component<AuthComponentProps, {}> {

    constructor(props: AuthComponentProps) {
        super(props);
        this.state = {};        
    }

    render() {
        let error: any = null;
        if (this.props.error) {
            error = <ErrorMessage
                message={this.props.error.message}
                debug={this.props.error.debug} />;
        }
               
        return (
                <div>
                    <NavBar
                        isAuthenticated={this.props.isAuthenticated}
                        authButtonMethod={this.props.isAuthenticated ? this.props.logout : this.props.login}
                        user={this.props.user} />
                    <Container>
                    {error}
                    <Routes>
                        <Route path="/configEditor"
                            element={
                                this.props.isAuthenticated ?
                                    <ConfigEditor {...this.props}
                                        isAuthenticated={this.props.isAuthenticated}
                                        user={this.props.user}
                                        authButtonMethod={this.props.login}
                                        getAccessToken={this.props.getAccessToken} /> :
                                    <Navigate to="/" />
                            } />
                        <Route path="/serviceManager"
                            element={
                                this.props.isAuthenticated ?
                                    <ServiceManager {...this.props}
                                        isAuthenticated={this.props.isAuthenticated}
                                        user={this.props.user}
                                        authButtonMethod={this.props.login}
                                        getAccessToken={this.props.getAccessToken} /> :
                                    <Navigate to="/" />
                            } />
                        <Route path="/secretManager"
                            element={
                                this.props.isAuthenticated ?
                                    <SecretManager {...this.props}
                                        isAuthenticated={this.props.isAuthenticated}
                                        user={this.props.user}
                                        authButtonMethod={this.props.login}
                                        getAccessToken={this.props.getAccessToken} /> :
                                    <Navigate to="/" />
                            } />
                    </Routes>
                    </Container>
                    <ToastContainer transition={Slide} limit={5} />
                </div>
        );
        
    }
}

export default (withAuthProvider(App));
